import { Component, Input } from '@angular/core';

/** Affiche l'estimation globale du projet, dont le montant de pose. */
@Component({
  selector: 'ng-casto-installation-price-range',
  templateUrl: './installation-price-range.component.html',
  styleUrls: ['./installation-price-range.component.scss'],
})
export class InstallationPriceRangeComponent {
  /** Montant total du projet (€ TTC). */
  @Input() total: number;
  /** Montant de la pose, inclus dans le total (€ TTC). */
  @Input() installation: number;
  /** Remplace les montants par un squelette pendant le chargement. */
  @Input() loading: boolean;
}
